import functions from './js/functions';
import lozad from 'lozad';

import './scss/style.scss';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import 'lightgallery/src/js/lightgallery.js';
import 'lightgallery/modules/lg-fullscreen.js';
import 'lightgallery/modules/lg-thumbnail.js';

import flatpickr from "flatpickr";
flatpickr.localize(flatpickr.l10ns[functions.getLang()]);
flatpickr.l10ns.default.firstDayOfWeek = 1;
import 'flatpickr/dist/l10n/sr.js';

import './js/components/datepicker';
import './js/components/gallery';
import './js/globals';
import './js/list';
import './js/details';
import './js/booking';
import './js/contact';
import './js/details/inquiry';
import './js/blog';
import './js/newsletter';
import './js/searchOffer';

window.observer = lozad('.lozad', {
    rootMargin: '200px 0px',
    loaded: el => {
        $(el).triggerHandler('lozadLoaded');
    }
});
window.observer.observe();

const script = document.createElement('script');
script.src = "https://www.google.com/recaptcha/enterprise.js?render=" + functions.getRecaptchaKey();
script.defer = true;
document.head.appendChild(script);